import reducerMap from 'wanderu-ducks-account';

import ReferredSignUp from '../containers/ReferredSignUp/ReferredSignUp';

function onLoad(module, info, props, context) {
    context.store.inject(reducerMap);
}

export { onLoad };
export default ReferredSignUp;
